import Tabs from "components/lib/Shared/Tabs";
import { useMemo, useState } from "react";
import SingnedUnsignedDocuments from "./SignedUnsignedDocuments";
import AuditTrail from "./AuditTrail";

/**
 * ESignature displays the documents signed electronically by the official.
 * It also displays the audit trail of the signing process.
 *
 *
 * @param row - The data row containing the official and document info
 * @returns
 */
const ESignature = ({ row }) => {
  /** Initialize default tabs */
  const initialTabs = useMemo(() => {
    return [
      {
        id: "changeDocuments",
        label: "Change Documents",
      },
      {
        id: "auditTrail",
        label: "Audit Trail",
      },
    ];
  }, [row]);

  // Set the initial tabs for the component
  const [tabs, setTabs] = useState(initialTabs);
  const [selectedTab, setSelectedTab] = useState(initialTabs[0]);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  if (row?.original?.envelopes?.length > 0) {
    return (
      <div>
        <Tabs
          tabs={tabs}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={setSelectedTabIndex}
        />

        {selectedTab.id === "changeDocuments" && (
          <SingnedUnsignedDocuments row={row} />
        )}
        {selectedTab.id === "auditTrail" && <AuditTrail row={row} />}
      </div>
    );
  } else {
    return (
      <div className="flex justify-center items-center h-64">
        <p className="text-gray-500">No documents signed electronically.</p>
      </div>
    );
  }
};

export default ESignature;
